import OffersListRenderer from "./OffersListRenderer";
import { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { db } from '../../../../../Config/firebase';
import { collection, query, onSnapshot, GeoPoint, orderBy } from 'firebase/firestore';
import { RootState, useAppSelector } from '../../../../../state/state';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { openModal } from '../../../../../state/ModalSlice/ModalSlice';

import noOffersImg from "../../../../../assets/GifsAndPlaceholders/noOffersUndraw.png"
import { selectEffectiveUID } from "../../../../../state/UserStatesV2/userSliceV2";

export enum OfferConstraint {
    WEEKDAY = "Weekday",
    WEEKEND = "Weekend",
    NON_HOLIDAYS = "Non Holidays",
    EVERYDAY = "Everyday"
}

export type Offer ={
    id: string;
    BuzzName: string;
    Description: string;
    OfferCode: string;
    isLive: boolean;
    url: string;
    offerConstraint: OfferConstraint;
    StartDate: firebase.firestore.Timestamp;
    EndDate: firebase.firestore.Timestamp;
    Price: number,
    placeName: string,
    placeAddress: string,
    geoLocation: eGeoLocation,
    participants: number,
    offerLink: string;
}

type eGeoLocation = {
    address: string;
    city: string;
    latlang: any; // [latitude, longitude]
    locality: string;
    pin: string;
    placeName: string;
    state: string;
    sublocalities: string[];
    formattedAddress: string;
}


export default function OffersContainer({ showAllOffers }: { showAllOffers: boolean }) {

    const [offers, setOffers] = useState<Offer[]>([]);
    const providerId: string = useAppSelector(selectEffectiveUID);
    const dispatch = useDispatch();


    // Reference to store the unsubscribe function
    const unsubscribeRef = useRef<() => void | undefined>();

    useEffect(() => {
        if (providerId) {
            const offersRef = collection(db, 'ServiceProviders', providerId, 'Offers');
            const q = query(offersRef, orderBy('createdAt', 'desc'));

            const unsubscribe = onSnapshot(q, (snapshot) => {
                const offersList: Offer[] = [];
                snapshot.forEach((doc) => {
                    offersList.push({ id: doc.id, ...doc.data()  } as Offer);
                });
                setOffers(offersList);
            }, (error) => {
                console.error("Error fetching offers: ", error);
            });

            // Store the unsubscribe function
            unsubscribeRef.current = unsubscribe;

            // Cleanup function
            return () => {
                if (unsubscribeRef.current) {
                    unsubscribeRef.current();
                }
            };
        }
    }, [providerId]);


    const filteredOffers: Offer[] = offers.filter(offer =>
        showAllOffers ? true : offer.isLive
    );

    const handleAddOffer = () => {
        dispatch(openModal('AddOfferModalOpen'));
    }




    return (
        <div className="flex flex-col items-center justify-center border-t-solid border-t-[2px] border-t-gray-200 pt-6 pb-8 ">
            {filteredOffers.length === 0 ? (
                <>
                    <img
                        src={noOffersImg}
                        alt="No offers"
                        className="w-52 h-auto mb-4"
                    />
                    <p className="text-gray-500 mb-2">No Offers Created Yet!</p>
                    <button onClick={handleAddOffer} className="text-blue-600 hover:text-blue-700">
                        Create Offer
                    </button>
                </>
            ) : (
                <div className="overflow-y-auto max-h-[50rem] w-full diff-scrollbar px-2">
                    {filteredOffers.map((offer) => (
                        <OffersListRenderer key={offer.id} offer={offer} />
                    ))}
                </div>
            )}
        </div>
    )
}